import styled from 'styled-components';
import {dFlex, dFlexBetween, dFlexCenter, dFlexColumn, alignCenter, justifyEnd} from '../../globalVariables/GlobalFlex';
import {LIGHT_GRAY5, GRAY3, mobileMedia, scrollbar, WHITE, DARK_GRAY} from '../../globalVariables/GlobalVariables';

export const running = styled.div`
    position: relative;
    inset-block-start: 20px;
`;

export const editorHeader = styled.div`
    ${dFlex};
    ${alignCenter};
    gap: 8px;
    color: ${GRAY3};
    margin-top: 12px;
    margin-bottom: 8px;
`;

export const headerText = styled.span`
    font-size: 14px;
    font-weight: 500;
    ${dFlexCenter};
`;

export const tabContent = styled.div`
    position: relative;
    height: calc(100% - 180px);
    padding: 20px;
    padding-inline: 40px;
    ${scrollbar}
    transition: all 200ms;
`;

export const actions = styled.div`
    padding: 20px;
    border-top: 1px solid ${LIGHT_GRAY5};
    ${dFlexBetween};
    ${mobileMedia} {
        ${dFlexColumn};
        gap: 12px;
    }
`;

export const actionButtons = styled.div`
    ${dFlex};
    gap: 12px;
    ${justifyEnd};
    ${mobileMedia} {
        ${alignCenter};
        gap: 8px;
    }
`;

export const senderInfo = styled.div`
    padding-inline-start: 20px;
    font-size: 14px;
    font-weight: 500;
    ${dFlex};
    ${alignCenter};
    gap: 8px;
`;

export const senderIcon = styled.div`
    ${dFlexCenter};
`;

export const messagesAmount = styled.span`
    padding: 6px 12px;
    margin-inline-start: 8px;
    height: 30px;
    color: ${DARK_GRAY};
    gap: 8px;
    border-radius: 31px;
    background-color: ${LIGHT_GRAY5};    
    ${dFlexCenter};
`;
export const numbers = styled.span`
    background-color: ${WHITE};
    padding: 0px 6px;
    font-size: 12px;
    border-radius: 50px;
    height: 20px;
    font-weight: 400;
    ${dFlexCenter};
`;

